import { Check } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { FlowItem } from './FlowItem';

import type { FlowAction, FlowItemModel } from '@lume/shared/worklist';

// Corrente P0 (kickoff 2026-07-10): a Calmaria nunca anestesia — sem itens,
// ela diz o que ainda pesa (pendências vencidas) em vez de "está tudo bem".
function Calm({ overduePendencies }: { overduePendencies?: number | undefined }): JSX.Element {
  const hasOverdue = overduePendencies !== undefined && overduePendencies > 0;
  return (
    <div className="calm">
      <div className="calm__glyph">
        <Check size={26} />
      </div>
      <h2>Sua corrente está vazia</h2>
      {hasOverdue ? (
        <p>
          Nenhuma conversa esperando agora — mas você tem{' '}
          <strong>
            {overduePendencies}{' '}
            {overduePendencies === 1 ? 'pendência vencida' : 'pendências vencidas'}
          </strong>
          .
        </p>
      ) : (
        <p>
          Nenhuma conversa esperando agora. Bom momento para adiantar o que ficou: pendências,
          retornos, agenda.
        </p>
      )}
      <Link className="minibtn" to="/pendencias">
        {hasOverdue ? 'Resolver pendências' : 'Ver pendências'}
      </Link>
    </div>
  );
}

const LOW_TIDE_PREVIEW = 3;

export function Corrente({
  items,
  onAction,
  onOpen,
  overduePendencies,
}: {
  items: FlowItemModel[];
  onAction: (a: FlowAction) => void;
  onOpen: (item: FlowItemModel) => void;
  overduePendencies?: number | undefined;
}): JSX.Element {
  const [expanded, setExpanded] = useState(false);
  if (items.length === 0) return <Calm overduePendencies={overduePendencies} />;
  const high = items.filter((i) => !i.lowTide);
  const low = items.filter((i) => i.lowTide);
  // P0 — o vazio nunca mente: sem urgentes, a prévia da maré baixa (já ordenada
  // por espera no adapter) aparece acima da dobra com rótulo honesto.
  // S5 — sugestões (ofertas, não clientes esperando) NUNCA entram na prévia
  // rotulada «estes esperam há mais tempo» (rótulo falso p/ uma oferta M6/M7);
  // seguem na maré baixa expandida normalmente.
  const fallback =
    high.length === 0 && !expanded
      ? low.filter((i) => i.kind !== 'suggestion').slice(0, LOW_TIDE_PREVIEW)
      : [];
  const visible = expanded ? items : high.length > 0 ? high : fallback;
  const hiddenLow = expanded ? 0 : high.length > 0 ? low.length : low.length - fallback.length;
  return (
    <>
      <div className="corr__head">
        <h2>Corrente</h2>
        <span className="hint">o que merece você agora — sobe por prioridade, não por horário</span>
      </div>
      {fallback.length > 0 && (
        <div className="corr__fallback-note">nada urgente — estes esperam há mais tempo:</div>
      )}
      <div className="corr-lane">
        {visible.map((it) => (
          <FlowItem key={it.id} item={it} onAction={onAction} onOpen={onOpen} />
        ))}
      </div>
      {hiddenLow > 0 && (
        <div
          className="tide-note"
          role="button"
          tabIndex={0}
          onClick={() => setExpanded(true)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') setExpanded(true);
          }}
        >
          ▾ mais {hiddenLow} {hiddenLow === 1 ? 'item' : 'itens'} em maré baixa
        </div>
      )}
    </>
  );
}
